import React, { useEffect, useState } from "react";
import { Input, Button, Row, Col, Typography, message } from "antd";
import { useForm, Controller } from "react-hook-form";
import Yup from "ValidationModels/localizedYup";
import { FormItem } from "Components/form";
import FetchSelect from "Components/fetch-select";
import { Link } from "react-router-dom";
import { useStoreActions, useStoreState } from "easy-peasy";
import { useLocation, useHistory } from "react-router";
import { ACTION_TYPES } from "Store/models/auth";
import { fixDates, clean } from "Utils/";
import { yupResolver } from "@hookform/resolvers";
import Fade from "react-reveal/Fade";

import building2 from "Assets/login/image/login-2.png";

const { Title, Text } = Typography;

const SignUpFormValidation = Yup.object().shape({
  name: Yup.string().required(),
  surname: Yup.string().required(),
  email: Yup.string().email().required(),
  password: Yup.string().required(),
  passwordConfirmation: Yup.string().oneOf(
    [Yup.ref("password"), null],
    "Şifreler eşleşmiyor"
  ),
});
export default function Signup({ ...props }) {
  const form = useForm({
    resolver: yupResolver(SignUpFormValidation),
  });

  const { control, handleSubmit, errors } = form;

  let location = useLocation();
  let history = useHistory();

  const { signup } = useStoreActions((store) => store.auth);
  const { process } = useStoreState((store) => store.auth);

  const signupFormSubmit = async (form) => {
    clean(form);
    signup(form);
  };

  useEffect(() => {
    if (process === ACTION_TYPES.SIGNED_UP) {
      message.success(
        "Hoş Geldiniz. Mail doğrulaması yaptıktan sonra giriş yapabilirsiniz."
      );
      history.push("/login");
    }
  }, [process]);

  return (
    <Row className="split-page-wrapper">
      <Col
        xs={24}
        md={12}
        className="form-wrapper end"
        style={{ backgroundColor: "#f2f2f2" }}
      >
        <div className="form">
          <Fade bottom cascade>
            <p style={{ textAlign: "right" }}>
              <Text style={{ fontSize: 18 }}>Hoş Geldiniz</Text>
              <br />
              <Text type={"secondary"}>Hesabınızı Oluşturun</Text>
            </p>
            <form onSubmit={handleSubmit(signupFormSubmit)}>
              <FormItem error={errors.name}>
                <Controller
                  name="name"
                  control={control}
                  as={<Input placeholder="Ad" />}
                />
              </FormItem>
              <FormItem error={errors.surname}>
                <Controller
                  name="surname"
                  control={control}
                  as={<Input placeholder="Soyad" />}
                />
              </FormItem>
              <FormItem error={errors.email}>
                <Controller
                  name="email"
                  control={control}
                  as={<Input placeholder="Email" />}
                />
              </FormItem>
              <FormItem error={errors.password}>
                <Controller
                  name="password"
                  control={control}
                  as={<Input.Password placeholder="Şifre" />}
                />
              </FormItem>
              <FormItem error={errors.passwordConfirmation}>
                <Controller
                  name="passwordConfirmation"
                  control={control}
                  as={<Input.Password placeholder="Şifreyi Doğrula" />}
                />
              </FormItem>
              <FormItem>
                <Controller
                  name="phone"
                  control={control}
                  as={<Input placeholder="Telefon" />}
                />
              </FormItem>
              <FormItem htmlFor="userUnit">
                <FetchSelect
                  api="/masterdata/userunits"
                  form={form}
                  field="userUnit"
                  placeholder="Kullanıcı birimi seçiniz"
                />
              </FormItem>
              <FormItem>
                <Button
                  loading={process === ACTION_TYPES.SIGNIN_UP}
                  block
                  type="primary"
                  htmlType="submit"
                >
                  Kayıt Ol
                </Button>
              </FormItem>
            </form>
            <p style={{ textAlign: "right" }}>
              Hesabınız mı var? <Link to="login">Giriş yapın</Link>
            </p>
          </Fade>
        </div>
      </Col>
      <Col
        xs={24}
        md={12}
        style={{ backgroundColor: "#a69d98", overflow: "hidden" }}
      >
        <Fade left>
          <img
            src={building2}
            style={{
              position: "absolute",
              left: -40,
              bottom: -50,
              height: "50vh",
            }}
          />
        </Fade>
      </Col>
    </Row>
  );
}
